module.exports = __webpack_public_path__ + "images/emoji/koko.12f07c5b132d8addec8a.png";